// Standard quick prompts for document Q&A
export const standardDocumentPrompts = [
  {
    prompt_id: 'std-summary',
    label: 'Summarize Document',
    prompt: 'Provide a comprehensive summary of this document, including its main purpose, key technical details, and important findings.',
  },
  {
    prompt_id: 'std-technical-problem',
    label: 'Technical Problem',
    prompt: 'What technical problem does this document address? Explain the problem statement and why it matters.',
  },
  {
    prompt_id: 'std-solution',
    label: 'Proposed Solution',
    prompt: 'What solution or approach does this document propose? Describe the key technical features and how they work.',
  },
  {
    prompt_id: 'std-advantages',
    label: 'Key Advantages',
    prompt: 'What are the main advantages or benefits of the technology/solution described in this document?',
  },
  {
    prompt_id: 'std-implementation',
    label: 'Implementation Details',
    prompt: 'Explain the implementation details. How would someone actually build or practice what is described in this document?',
  },
  {
    prompt_id: 'std-novelty',
    label: 'Novel Features',
    prompt: 'What are the novel or innovative aspects of this document? What makes it different from existing solutions?',
  },
  {
    prompt_id: 'std-applications',
    label: 'Applications & Use Cases',
    prompt: 'What are the potential applications and use cases for the technology described in this document?',
  },
  {
    prompt_id: 'std-components',
    label: 'Key Components',
    prompt: 'List and explain the key components, elements, or parts described in this document and how they interact.',
  },
  {
    prompt_id: 'std-limitations',
    label: 'Limitations',
    prompt: 'What are the limitations, challenges, or potential drawbacks mentioned or implied in this document?',
  },
  {
    prompt_id: 'std-claims-analysis',
    label: 'Claims Analysis',
    prompt: 'Analyze the claims (if applicable). What is the scope of protection? What are the independent and dependent claims covering?',
  },
  {
    prompt_id: 'std-prior-art',
    label: 'Prior Art Discussion',
    prompt: 'What prior art or background technology is discussed? How does this document differ from or improve upon it?',
  },
  {
    prompt_id: 'std-figures',
    label: 'Explain Figures',
    prompt: 'Explain the figures/drawings. What do they illustrate and how do they relate to the described technology?',
  },
];
